import { call, put, takeEvery } from 'redux-saga/effects';
import { setError } from '../reducers/error';
import { setLoader } from '../reducers/loader';
import {
  confirm_edit_sip,
  fetch_available_switch_funds,
  fetch_external_portfolio_summary,
  fetch_mf_summary,
  fetch_more_transactions,
  fetch_pending_transactions,
  fetch_portfolio_summary,
  fetch_rta_transactions,
  fetch_sips,
  fetch_switch_fund_details,
  fetch_switch_taxes,
  fetch_your_funds,
  place_switch_orders,
  post_sip_action,
  resend_switch_otp,
  submit_sip_action_otp,
  verify_edit_sip,
  verify_switch_otp,
} from '../../apis/portfolio';
import {
  getAvailableSwitchFunds,
  getCompleteSwitchDetails,
  getMfPortfolioSummary,
  getPortfolioSummary,
  getSwitchFundDetails,
  setAvailableSwitchFunds,
  setMfPortfolioSummary,
  setPortfolioSummary,
  setPfStatusCode,
  setMpfStatusCode,
  setSwitchFundDetails,
  getSwitchOtpDetails,
  setSwitchOtpDetails,
  resendSwitchOtpDetails,
  verifySwitchOtp,
  getYourFunds,
  setYourFunds,
  getFundSips,
  setFundSips,
  getFundOrders,
  setFundOrders,
  fetchPendingOrders,
  setPendingOrders,
  fetchAllHoldingFunds,
  setMoreTransactionsData,
  updateFundOrders,
  fetchMoreTransactions,
  setIsCallPortfolioApis,
  setUpcomingSipsData,
  setAllSipsData,
  fetchFundOrderDetails,
  setFundOrderDetails,
  updateEditSipData,
  updateSipAction,
  updateSelectedSip,
  submitSipOtp,
  fetchExternalPortfolioSummary,
  setExternalPortfolioSummary,
  fetchSwitchTaxes,
} from '../reducers/portfolioV2';
import { get, isEmpty, noop } from 'lodash-es';
import { COMMON } from '../../strings/common';
import { fetchfundsInfo } from '../../apis/mfOrders';

export default function* handlePortfolioSaga() {
  yield takeEvery(getPortfolioSummary.toString(), handleFetchPortfolioSummary);
  yield takeEvery(getMfPortfolioSummary.toString(), handleFetchMfPortfolioSummary);
  yield takeEvery(getSwitchFundDetails.toString(), handleFetchSwitchFundDetails);
  yield takeEvery(getAvailableSwitchFunds.toString(), handleFetchAvailableSwitchFunds);
  yield takeEvery(getCompleteSwitchDetails.toString(), handleFetchCompleteSwitchDetails);
  yield takeEvery(getSwitchOtpDetails.toString(), handleFetchSwitchOtpDetails);
  yield takeEvery(resendSwitchOtpDetails.toString(), handleFetchResendSwitchOtpDetails);
  yield takeEvery(verifySwitchOtp.toString(), handleFetchVerifySwitchOtpDetails);
  yield takeEvery(getYourFunds.toString(), handleFetchYourFunds);
  yield takeEvery(getFundSips.toString(), handleFetchFundSips);
  yield takeEvery(getFundOrders.toString(), handleFetchFundOrders);
  yield takeEvery(fetchPendingOrders.toString(), handleFetchPendingOrders);
  yield takeEvery(fetchAllHoldingFunds.toString(), handleFetchAllHoldingFunds);
  yield takeEvery(fetchMoreTransactions.toString(), handleFetchMoreOrders);
  yield takeEvery(fetchFundOrderDetails.toString(), handleFetchFundOrderDetails);
  yield takeEvery(updateEditSipData.toString(), handleUpdateEditSip);
  yield takeEvery(updateSipAction.toString(), handleUpdateSipAction);
  yield takeEvery(submitSipOtp.toString(), handleSubmitSipOtp);
  yield takeEvery(fetchExternalPortfolioSummary.toString(), handleFetchExternalPortfolioSummary);
  yield takeEvery(fetchSwitchTaxes.toString(), handleFetchSwitchTaxes);
}

function* handleFetchPortfolioSummary({ payload }) {
  const { Api, token, screen } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const { result, status } = yield call(fetch_portfolio_summary, Api, token);
    yield put(setPortfolioSummary(result));
    yield put(setPfStatusCode(status));
    yield put(setIsCallPortfolioApis({isPortfolioApiCall: false}))
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchPortfolioSummary');
    } else {
      console.log('error while fetching portfolio summary is', err.message);
      yield put(setError({ screen, isFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchMfPortfolioSummary({ payload }) {
  const { Api, token, screen } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const { result, status } = yield call(fetch_mf_summary, Api, token);
    yield put(setMfPortfolioSummary(result));
    yield put(setMpfStatusCode(status));
    yield put(setIsCallPortfolioApis({isMfPortfolioApiCall: false}))
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchMfPortfolioSummary');
    } else {
      console.log('error while fetching mf portfolio summary is', err.message);
      yield put(setError({ screen, isFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchExternalPortfolioSummary({ payload }) {
  const { Api, token, screen } = payload;
  try {
    yield put(setLoader({ screen, isExternalPortfolioLoading: true }));
    yield put(
      setError({
        screen,
        isExternalPortfolioFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const result = yield call(fetch_external_portfolio_summary, Api, token);
    yield put(setExternalPortfolioSummary(result));
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchMfPortfolioSummary');
    } else {
      console.log('error while fetching mf portfolio summary is', err.message);
      yield put(setError({ screen, isExternalPortfolioFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isExternalPortfolioLoading: false }));
  }
}

function* handleFetchSwitchFundDetails({ payload }) {
  const { Api, token, screen, amfi } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const fundDetails = yield call(fetch_switch_fund_details, Api, amfi, token);
    const fundReports = get(fundDetails, 'report', {});
    yield put(setSwitchFundDetails(fundReports));
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchSwitchFundDetails');
    } else {
      console.log('error while fetching switch fund details is', err);
      yield put(setError({ screen, isFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchAvailableSwitchFunds({ payload }) {
  const { Api, token, screen, amfi } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const availableFunds = yield call(fetch_available_switch_funds, Api, amfi, token);
    const switchMfs = get(availableFunds, 'switch_mfs', []);
    yield put(setAvailableSwitchFunds(switchMfs));
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchAvailableSwitchFunds');
    } else {
      console.log('error while fetching available switch funds is', err);
      yield put(setError({ screen, isFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchCompleteSwitchDetails({ payload }) {
  const { Api, token, screen, amfi, sagaCallback=noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const fundDetails = yield call(fetch_switch_fund_details, Api, amfi, token);
    const fundReports = get(fundDetails, 'report', {});
    yield put(setSwitchFundDetails(fundReports));
    if (fundReports.switch_possible) {
      const availableFunds = yield call(fetch_available_switch_funds, Api, amfi, token);
      const switchMfs = get(availableFunds, 'switch_mfs', []);
      yield put(setAvailableSwitchFunds(switchMfs));
    }
    yield call(sagaCallback, fundReports);
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchCompleteSwitchDetails');
    } else {
      console.log('error while fetching complete switch details is', err.message);
      yield put(setError({ screen, isFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchSwitchOtpDetails({ payload }) {
  const { Api, token, screen, body={}, sagaCallback=noop } = payload;
  try {
    yield put(setLoader({ screen, isButtonLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const switchOtpDetails = yield call(place_switch_orders, Api, body, token);
    yield put(setSwitchOtpDetails(switchOtpDetails));
    yield call(sagaCallback);
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchSwitchOtpDetails');
    } else {
      console.log('error while fetching switch orders is', err.message);
      yield put(setError({ screen, isUpdateFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isButtonLoading: false }));
  }
}

function* handleFetchResendSwitchOtpDetails({ payload }) {
  const { Api, endPoint, screen, sagaCallback=noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const switchOtpDetails = yield call(resend_switch_otp, Api, endPoint);
    yield put(setSwitchOtpDetails(switchOtpDetails));
    yield call(sagaCallback);
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchResendSwitchOtpDetails');
    } else {
      console.log('error while resend switch otp is', err.message);
      yield put(setError({ screen, isFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchVerifySwitchOtpDetails({ payload }) {
  const { Api, endPoint, screen, otp, sagaCallback=noop } = payload;
  try {
    yield put(setLoader({ screen, isButtonLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    yield call(verify_switch_otp, Api, endPoint, otp);
    yield call(sagaCallback);
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchVerifySwitchOtpDetails');
    } else {
      console.log('error while verifying switch otp is', err.message);
      yield put(setError({ screen, isUpdateFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isButtonLoading: false }));
  }
}

function* handleFetchYourFunds({payload}) {
  const {Api, token, screen} = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const response = yield call(fetch_your_funds, Api, token);
    const yourFundsData = get(response, 'data', {});
    yield put(setYourFunds(yourFundsData));
    yield put(setIsCallPortfolioApis({isYourFundsApiCall: false}));
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchYourFunds');
    } else {
      console.log('error while fetching your funds is', err);
      yield put(setError({ screen, isFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchFundSips({payload}) {
  const {Api, token, screen, isin, isUpcoming} = payload;
  try {
    yield put(setLoader({ screen, isSipsLoading: true }));
    yield put(
      setError({
        screen,
        isSipsFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const response = yield call(fetch_sips, Api, isin, isUpcoming, token);
    const result = get(response, "data", {});
    if (!isEmpty(isin)) {
      const fundSips = get(response, 'data.sips', []);
      yield put(setFundSips(fundSips));
    } else if (isUpcoming) {
      yield put(setUpcomingSipsData(result));
      yield put(setIsCallPortfolioApis({ isUpcomingSipLandingApiCall: false }))
    } else {
      yield put(setAllSipsData(result));
      yield put(setIsCallPortfolioApis({ isSipLandingApiCall: false }))
    }
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchFundSips');
    } else {
      console.log('error while fetching fund sips is', err);
      yield put(setError({ screen, isSipsFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isSipsLoading: false }));
  }
}

function* handleFetchFundOrders({payload}) {
  const {Api, token, screen, isin, ttype, scheme_category, scheme_subcategory, from_tdate, to_tdate} = payload;
  try {
    yield put(setLoader({ screen, isOrderLoading: true }));
    yield put(
      setError({
        screen,
        isOrderFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const response = yield call(fetch_rta_transactions, Api, isin, ttype, scheme_category, scheme_subcategory,from_tdate, to_tdate, token);
    const fundOrders = get(response, 'data.orders', []);
    const data = get(response, 'data', {});
    const moreTransactionData = {
      nextPage: data.next_page,
      more: data.more,
    }
    yield put(setMoreTransactionsData(moreTransactionData));
    yield put(setFundOrders(fundOrders));
    yield put(setIsCallPortfolioApis({ isYourOrdersApiCall: false, isRtaTransactionsApiCall: false}));
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchFundOrders');
    } else {
      console.log('error while fetching fund orders is', err);
      yield put(setError({ screen, isOrderFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isOrderLoading: false }));
  }
}

function* handleFetchMoreOrders({ payload }) {
  const { Api, token, screen, url } = payload;
  try {
    yield put(setLoader({ screen, isMoreTransactionsLoading: true }));
    yield put(
      setError({
        screen,
        isOrderFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const response = yield call(fetch_more_transactions, Api, url, token);
    const data = get(response, 'data', {});
    const fundOrders = get(data, 'orders', []);
    const moreTransactionData = {
      nextPage: data.next_page,
      more: data.more,
    }
    yield put(setMoreTransactionsData(moreTransactionData));
    yield put(updateFundOrders(fundOrders));
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchMoreOrders');
    } else {
      console.log('error while fetching more orders is', err);
      yield put(setError({ screen, isOrderFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isMoreTransactionsLoading: false }));
  }
}

function* handleFetchAllHoldingFunds({payload}) {
  const {Api, token, screen, isin, ttype, scheme_category, scheme_subcategory} = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const fundSipResponse = yield call(fetch_sips, Api, isin, token);
    const fundSips = get(fundSipResponse, 'data.sips', []);
    yield put(setFundSips(fundSips));
    const response = yield call(fetch_rta_transactions, Api, isin, ttype, scheme_category, scheme_subcategory, token);
    const fundOrders = get(response, 'data.orders', []);
    yield put(setFundOrders(fundOrders));
    const data = get(response, 'data', {});
    const moreTransactionData = {
      nextPage: data.next_page,
      more: data.more,
    }
    yield put(setMoreTransactionsData(moreTransactionData));
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchAllHoldingFunds');
    } else {
      console.log('error while fetching complete holding funds is', err);
      yield put(setError({ screen, isFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchPendingOrders({payload}) {
  const { Api, token, screen } = payload;
  try {
    yield put(setLoader({ screen, isFetchingPendingOrders: true }));
    yield put(
      setError({
        screen,
        isFetchPendingOrdersFailed: false,
        message: '',
      })
    );
    const response = yield call(fetch_pending_transactions, Api, token);
    const fundOrders = get(response, 'data.orders', []);
    yield put(setPendingOrders(fundOrders));
    yield put(setIsCallPortfolioApis({ isYourOrdersApiCall: false }));
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchFundPendingOrders');
    } else {
      console.log('error while fetching fund pending orders is', err);
      yield put(setError({ screen, isFetchPendingOrdersFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isFetchingPendingOrders: false }));
  }
}

function* handleFetchFundOrderDetails({ payload }) {
  const { Api, isins, token, screen, investmentType } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const fundOrderDetails = yield call(fetchfundsInfo, Api, investmentType, isins, token);
    const fundsData = get(fundOrderDetails, 'funds_data', []);
    yield put(setFundOrderDetails(fundsData));
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleFetchFundOrderDetails');
    } else {
      console.log("handleFetchFundOrderDetails error is", err);
      yield put(setError({ screen, isFetchFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleUpdateEditSip({ payload }) {
  const { Api, data, token, confirmEditPayload, screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isButtonLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const verifyEditSipResult = yield call(verify_edit_sip, Api, data, token);
    const isMandateLimitExceded = get(verifyEditSipResult, 'modification.action_required', false);
    if (isMandateLimitExceded) {
      yield call(sagaCallback, isMandateLimitExceded);
      return;
    }
    const confirmEditSipResult = yield call(confirm_edit_sip, Api, confirmEditPayload, token);
    yield put(updateSelectedSip({ successData: confirmEditSipResult }));
    yield put(setIsCallPortfolioApis({ isMfPortfolioApiCall: true, isSipLandingApiCall: true, isPortfolioApiCall: true, }));
    yield call(sagaCallback);
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleUpdateEditSip');
    } else {
      console.log("handleUpdateEditSip error is", err);
      yield put(setError({ screen, isUpdateFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isButtonLoading: false }));
  }
}

function* handleUpdateSipAction({ payload }) {
  const { Api, data, token, screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isButtonLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const result = yield call(post_sip_action, Api, data, token);
    const isResumeOrRestart = ["resume", "restart"].includes(data.action);
    const keyName = isResumeOrRestart ? "successData" : "otpData";
    yield put(updateSelectedSip({ [keyName]: result }));
    if (isResumeOrRestart) {
      yield put(setIsCallPortfolioApis({ isMfPortfolioApiCall: true, isSipLandingApiCall: true, isPortfolioApiCall: true, }));
    }
    yield call(sagaCallback);
  } catch (err) {
    if (err === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleUpdateSipAction');
    } else {
      console.log("handleUpdateSipAction error is", err);
      yield put(setError({ screen, isUpdateFailed: true, message: err.message }));
    }
  } finally {
    yield put(setLoader({ screen, isButtonLoading: false }));
  }
}

function* handleSubmitSipOtp({ payload }){
  const { Api, data, screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isButtonLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: ""
      })
    );
    const result = yield call(submit_sip_action_otp, Api, data);
    yield put(updateSelectedSip({ successData: result }));
    yield put(setIsCallPortfolioApis({ isMfPortfolioApiCall: true, isSipLandingApiCall: true, isPortfolioApiCall: true, }));
    yield call(sagaCallback)
  } catch (error) {
    if (error === COMMON.ApiCancelled) {
      console.log('Api cancelled for handleSubmitSipOtp');
    } else {
      console.log("handleSubmitSipOtp error is", error);
      yield put(setError({ screen, isFetchFailed: true, message: error.message }));
    }
  } finally {
    yield put(setLoader({ screen, isButtonLoading: false}));
  }
}

function* handleFetchSwitchTaxes({ payload }){
	const { Api, data, screen, sagaCallback = noop } = payload;
	try {
	  yield put(setLoader({ screen, isButtonLoading: true }));
	  yield put(
		setError({
		  screen,
		  isFetchFailed: false,
		  isUpdateFailed: false,
		  message: ""
		})
	  );
	  const result = yield call(fetch_switch_taxes, Api, data);
	  yield call(sagaCallback, result);
	} catch (error) {
	  if (error === COMMON.ApiCancelled) {
		console.log('Api cancelled for handleFetchSwitchTaxes');
	  } else {
		console.log("handleFetchSwitchTaxes error is", error);
		yield put(setError({ screen, isFetchFailed: true, message: error.message }));
	  }
	} finally {
	  yield put(setLoader({ screen, isButtonLoading: false}));
	}
}